import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DivisionInfo } from '../model/division.model';
import { TimeSheetChecklistInfo, TimeSheetChecklistYearInfo } from '../model/timesheetChecklist.model';

@Component({
  selector: 'app-timesheet-checklist-year-all',
  templateUrl: './timesheet-checklist-year-all.component.html',
  styleUrls: ['./timesheet-checklist-year-all.component.css']
})
export class TimesheetChecklistYearAllComponent implements OnInit {

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;

  //Primary data
  modelOnPromise: Promise<TimeSheetChecklistYearInfo[]>
  modelList: TimeSheetChecklistYearInfo[] = [];

  //Search Conditions
  isSearchSubmitted: boolean = false;
  txtSchYear: string = "";
  YearList: string[] = [];

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number;
  public itemTotal: any;
  public totalPages: number;
  public pagesize: number = 15;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private location: Location, private activatedRoute: ActivatedRoute) { 
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;

    GlobalService.CheckPagingAccessRights();
  }

  //============================ ngOnInit [Start] ===============================================
  ngOnInit(): void {
    this._EmpCode = localStorage.getItem("EmpCode");

    this.currentPageNumber = 1;
    this.LoadData();
  }
  //============================ ngOnInit [End] ===============================================

    //============================ onEvent [Start] ===============================================
    btnClick_setfilter() {
      this.isSearchSubmitted = true;
      this.LoadData();
    }
    btnClick_unsetFilter() {
      this.txtSchYear = "";
      this.isSearchSubmitted = false;
      this.LoadData();
    }
    //============================ onEvent [End] ===============================================
  
      //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getTimesheetChecklistYear()
      .then(
        data => {
          this.modelList = data;
          this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          this.itemTotal = (this.modelList.length != 0) ? data[0].rowTotal : 0;
        }
      ).then(() => {
        if (this.itemTotal == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.itemTotal / environment.PageSize)
      })
  }

  async getTimesheetChecklistYear(): Promise<TimeSheetChecklistYearInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      let year = this.checkUndefinedString(this.txtSchYear);
      year = (year != null && year != "") ? "01-01-"+year: year;

      var objectjson = {}; 

      objectjson['TimeSheetDate'] = year;
      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.modelOnPromise = this.httpClient
        .post<TimeSheetChecklistYearInfo[]>(this.baseurl + "TimeSheet/GetChecklistTimesheetByYearAll",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

   //============================ Data Loading [End] =========================================

  //============================ Misc Functions [Start] =========================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput;

  }
  //============================ Misc Function [End] =========================================

  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
  //============================ Pagination [End] =========================================

}
